/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ condition: NonNullable<unknown> }} Ui_Weather_Intensity_UnknownInputs */

const en_ui_weather_intensity_unknown = /** @type {(inputs: Ui_Weather_Intensity_UnknownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.condition} · intensity unknown`)
};

const de_ui_weather_intensity_unknown = /** @type {(inputs: Ui_Weather_Intensity_UnknownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.condition} · Stärke unbekannt`)
};

/**
* | output |
* | --- |
* | "{condition} · intensity unknown" |
*
* @param {Ui_Weather_Intensity_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_intensity_unknown = /** @type {((inputs: Ui_Weather_Intensity_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Intensity_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_intensity_unknown(inputs)
	return de_ui_weather_intensity_unknown(inputs)
});